import React from "react";

interface Props {
  title: string;
  link: string;
  description: string;
  image: string;
}

export default function RelatedVideo({
  title,
  link,
  description,
  image,
}: Props) {
  return (
    <div className="video relate-lg">
      <a href={link}>
        <div className="video-ui icon-play" title={title}>
          <img src={image} alt={title} title={title} />
        </div>
      </a>
      <a href={link} className="title">
        {title}
      </a>
      <div className="clearfix" />
      <p
        className="description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
}
